import React, { useState } from 'react';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { toKey, types } from '@tmap/mmm-core/entityKey';
import ContributionMedia from '../../communityContent/contributionMedia';
import useImpressions, { ImpressionTracker } from '../../../hooks/useImpressions';

const VideoWrapper = styled('div', {
  shouldForwardProp: (p) => p !== 'color',
})(({ theme, color = 'pink' }) => ({
  position: 'relative',
  border: `4px solid ${theme.palette[color].light}`,
  borderRadius: '16px',
  overflow: 'hidden',
  width: '675px',
  height: '340px',
  maxWidth: '100%',
  [theme.breakpoints.down()]: {
    width: '500px',
  },
}));

const ColoredTypography = styled(Typography, {
  shouldForwardProp: (p) => p !== 'color',
})(({ theme, color = 'pink' }) => ({
  color: theme.palette[color].light,
}));

function FeatureVideo(props) {
  const {
    overline,
    heading,
    content = [],
    color,
    blockIndex,
    isPreview = false,
  } = props;
  const contribution = content?.[0]?.contribution;
  const video = contribution?.media?.find((m) => m.type === 'video' || m.type === 'videoEmbed');
  const { trackView, trackClick } = useImpressions(
    contribution ? toKey(types.CONTRIBUTION, contribution._id) : '',
    !isPreview && `contentBlock-${blockIndex}-featureVideo`,
  );
  // only track first click impression (click through rate)
  const [clicked, setClicked] = useState(false);
  const handleFirstPlay = () => {
    if (!clicked) {
      setClicked(true);
      trackClick();
    }
  };
  if (!video) return null;
  return (
    <Grid container spacing={4.5}>
      <Grid item xs={12} md>
        {overline && (
          <ColoredTypography color={color} variant='overline' letterSpacing='0.15px' marginBottom={1}>
            {overline}
          </ColoredTypography>
        )}
        {heading && (
          <Typography color='text.primary' variant='h6' fontSize='22px' fontWeight={800} lineHeight='160%' letterSpacing='0.15px'>
            {heading}
          </Typography>
        )}
      </Grid>
      <Grid item xs={12} md={9}>
        <ImpressionTracker trackView={trackView}>
          <VideoWrapper color={color} onClickCapture={handleFirstPlay}>
            <ContributionMedia
              media={video}
              borderRadius={0}
              height={500}
              fitWidth
              fitHeight
            />
          </VideoWrapper>
        </ImpressionTracker>
      </Grid>
    </Grid>
  );
}

export default FeatureVideo;
